const LS_KEY_NAME = 'delivery_import_upload_id'

export const setDeliveryImportIdtoLs = (id) => localStorage.setItem(LS_KEY_NAME, id)
export const getDeliveryImportIdFromLs = () => localStorage.getItem(LS_KEY_NAME)
export const removeDeliveryImportIdFromLs = () => localStorage.removeItem(LS_KEY_NAME)
